import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot,RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  private loginDataSubject!: BehaviorSubject<any>;
  public loginData!: Observable<any>;

  public isReportClicked:any = new BehaviorSubject(false);

    constructor(private _router:Router ) {
      this.loginDataSubject = new BehaviorSubject<any>(null);
      this.loginData = this.loginDataSubject.asObservable();
    }

    public isLogIn:any = new BehaviorSubject('false')

    isLoggedIn() {
      const token = sessionStorage.getItem('token');
      token? this.isLogIn.next(true): this.isLogIn.next(false)
     return token? true: false
    }

    setLoginData(data: any): void {
      this.loginDataSubject.next(data);
    }

    setReportClicked(click: boolean) {
      this.isReportClicked.next(click)
    }

    getLoginData(): any {
      return this.loginDataSubject.value;
    }

}
